import Image from 'next/image';
import styled from 'styled-components';
import { Job } from '../../../model/Job';
import { device } from '../../../styles/device';
import StyledLink from '../../global/StyledLink';
import UploadSVG from '/public/svg/img.svg';
import CareerLevelSVG from '/public/svg/jobs/careerLevel.svg';
import EmploymentTypeSVG from '/public/svg/jobs/employmentType.svg';
import LocationSVG from '/public/svg/jobs/location.svg';
import RemoteTypeSVG from '/public/svg/jobs/remoteType.svg';

interface Props {
    job: Job,
    bucketURL: string
}

const LogoPlaceholderContainer = styled.div`
  border-radius: 12px;
  height: 70px;
  width: 70px;
  @media ${device.tablet} {
    height: 100px;
    width: 100px;
  }
  border: none;
  background-color: ${(props) => props.theme.colors.buttonSubtle};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
      height: 30px;
      width: 30px;
  }
  @media ${device.tablet} {
    svg {
        height: 40px;
        width: 40px;
    }
  }
`;

const JobsHeaderContainer = styled.div`
    display: grid;
    padding: 15px 0px; 
    column-gap: 24px;
    grid-template-columns: 1fr;
    grid-template-rows: auto;

    @media ${device.tablet} {
        grid-template-columns: 120px auto;
        grid-template-rows: 120px;
    }
`;
const JobsHeaderLogo = styled.div`
    
`;
const JobsHeaderContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: space-between;
    row-gap: 12px;

    @media ${device.tablet} {
        row-gap: 0;
    }

    p {
        margin: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        font-weight: 700;
        font-size: 15px;
        line-height: 20px;
    }

    svg {
        fill: ${props => props.theme.colors.fontBlack};
        margin-right: 5px;
    }

    .job-header-company-name {
        font-weight: 700;
        font-size: 18px;
        line-height: 25px;
        color: ${props => props.theme.colors.secondary};
    }

    .job-header-job-title {
        font-weight: 800;
        font-size: 22px;
        line-height: 28px;
    }
    .job-header-job-details {
        display: flex;
        flex-direction: row;
        align-items: center;
        column-gap: 24px;
    }
    .job-header-row {
        display: flex;
        flex-direction: column;
        row-gap: 8px;
    }
`;

export default function JobsHeader({ job, bucketURL }: Props) {
    return (
        <JobsHeaderContainer>
            <StyledLink href={`/companies/${job.company?.slug}`}>
                <JobsHeaderLogo>
                    {job.company?.logoUrl != null && job.company?.logoUrl != "" ?
                        <Image priority loading='eager' quality={100} src={bucketURL + job.company?.logoUrl} alt="Company Logo" height={120} width={120} />
                        :
                        <LogoPlaceholderContainer>
                            <UploadSVG />
                        </LogoPlaceholderContainer>
                    }
                </JobsHeaderLogo>
            </StyledLink>
            <JobsHeaderContent>
                <div>
                    <StyledLink href={`/companies/${job.company?.slug}`}>
                        <p className='job-header-company-name'>{job.company?.name}</p>
                    </StyledLink>
                    <p className='job-header-job-title'>{job.title}</p>
                </div>
                <div className='job-header-row'>
                    <div className='job-header-job-details'>
                        {job.employmentType != null && job.employmentType?.length > 0 &&
                            <p><EmploymentTypeSVG />{job.employmentType}</p>
                        }
                        {job.careerLevel != null && job.careerLevel?.length > 0 &&
                            <p><CareerLevelSVG /> {job.careerLevel}</p>
                        }
                    </div>
                    <div className='job-header-job-details'>
                        {job.city != null && job.city?.length > 0 &&
                            <p><LocationSVG />{job.city} </p>
                        }
                        {job.remoteType != null && job.remoteType?.length > 0 &&
                            <p><RemoteTypeSVG />{job.remoteType}</p>
                        }
                    </div>
                </div>

            </JobsHeaderContent>
        </JobsHeaderContainer>
    )
}
